/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import { setPagination } from "@/utils/helpers/pagination";

export default {
  SET_LIST(state, data) {
    state.list = data.data;
    state.totalRows = data.recordsTotal;
    if (data && data.pagination) {
      state.pagination = { ...state.pagination, ...data.pagination };
    }
  },
  SET_USER_CONTACT_INFOMATION(state, data) {
    state.userContactInfomation = data;
  },
  SET_DETAIL(state, workingtime) {
    state.selecting = workingtime;
  },
  ADD_RECORD(state, workingtime) {
    state.list.push(workingtime);
  },
  UPDATE_RECORD(state, workingtime) {
    const index = state.list.findIndex((u) => u.id === workingtime.id);
    if (index >= 0) {
      state.list.splice(index, 1, workingtime);
    }
  },
  REMOVE_RECORD(state, itemId) {
    const index = state.list.findIndex((u) => u.id === itemId);
    state.list.splice(index, 1);

    state.pagination = setPagination(state.pagination, itemId);
  },

  SET_CURRENT_PAGE(state, data) {
    state.currentPage = data;
  },

  SET_PER_PAGE(state, data) {
    state.perPage = data;
  },
};
